<template>
    <div class="animated fadeIn">
        <b-card>
            <b-card-header>
                <i class="icon-menu mr-1"></i>Очередь

            </b-card-header>
            <b-card-body>
                <div id="events">
                    <v-server-table :url="apiurl('queue/table')"  :columns="columns" :options="options" :theme="theme" id="queueTable" ref="queueTable" name="queueTable30">
                        <div slot="child_row" slot-scope="props">

                        </div>

                        <span slot="user_creator_id" slot-scope="props"></span>
                    </v-server-table>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>

    import Vue from 'vue'
    import { ServerTable, Event} from 'vue-tables-2'
    import { functions } from '@/functions.js';
    import date_create_iso from '../jsx/logs/date_create_iso'
    import comment_text from '../jsx/logs/comment_text'
    import {CONSTANTS} from '@/constants';

    Vue.use(ServerTable)

    export default {
        name: 'NsbAdminQueue',
        components: { ServerTable, Event,  },
        mixins: [functions],
        data: function () {
            return {
                columns: ['id', 'user_id', 'created_at', 'postponed_till', 'started_at', 'finished_at', 'failed_at', 'attempts', 'max_attempts', ],
                options: {
                    saveState: true,
                    headings: {
                        id: '',

                    },
                    dateColumns:[

                    ],
                    columnsDisplay: {

                    },
                    sortable: [],
                    filterable: [],
                    sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
                    pagination: {
                        chunk: 10,
                        edge: false,
                        nav: 'scroll'
                    },
                    filterByColumn: true,
                    templates: { },
                    debounce: CONSTANTS.DEBOUNCE,
                    texts: CONSTANTS.DATA_TABLE_LANG,
                },
                theme: 'bootstrap4',
                template: 'default'
            }
        },
        methods: {
        },
        created: function() {
        },
        mounted: function () {
            Event.$on('vue-tables.loading', ()=>{ /* this.$eventHub.$emit('loading_start'); */ });
            Event.$on('vue-tables.loaded',()=>{ /*this.$eventHub.$emit('loading_end'); */ });
        },

    };
</script>

<style lang="scss">

</style>
